/**
 * @file root layout
 * 1. 注入 account 数据到 context 中
 * @author Yangholmes 2024-03-20
 */

import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { ActionTypeValues, namespace, StoreContext } from '@/context';
import { IUserLoginInfo, IUserPermission } from '@/api/user';
import { useSensors } from '@/hooks';
import FloatContainer from '@/components/FloatContainer/container';
import { isMiniProgram } from '@/utils/miniProgram';
import { homeRouterPageName } from '@/constants/url';
import { isMimoHomeListEntry } from '@/utils/url';

interface RootLayoutProps {
  children: React.ReactNode;
  account: IUserLoginInfo | {};
  permission: IUserPermission;
}

export default function RootLayout({
  children,
  account,
  permission,
}: RootLayoutProps) {
  const router = useRouter();
  const { dispatch } = useContext(StoreContext);

  useSensors({dispatch});

  useEffect(() => {
    if (account) {
      dispatch({
        namespace: namespace.app,
        type: ActionTypeValues.UPDATE_ACCOUNT,
        payload: account
      });
    }
  }, [account])

  useEffect(() => {
    if (permission) {
      dispatch({
        namespace: namespace.app,
        type: ActionTypeValues.UPDATE_PERMISSION,
        payload: permission
      });
    }
  }, [permission])

  const [hiddenFloatContainer, setHiddenFloatContainer] = useState(true);

  useEffect(()=>{
    const isMini = isMiniProgram(window.navigator.userAgent);
    const isProfilepage = router.pathname === homeRouterPageName.profile;
    setHiddenFloatContainer(isMini || isProfilepage || isMimoHomeListEntry());
  }, [])

  return (
    <>
      {children}
      {!hiddenFloatContainer && <FloatContainer /> }
    </>
  )
}
